/**
 * converts string to start case
 *
 * @param {string} str
 * @return {*}  {string}
 *
 * @example
 * startCase('--foo-bar--');
 * // returns 'Foo Bar'
 */
export var startCase = function (str) { return str
    .replace(/[^A-Za-z0-9]+/g, ' ')
    .replace(/\w*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }); };
//# sourceMappingURL=startCase.js.map